import { render } from "./module2.vue?vue&type=template&id=37a4711f&scoped=true&ts=true"
import script from "./module2.vue?vue&type=script&lang=ts"
export * from "./module2.vue?vue&type=script&lang=ts"

import "./module2.vue?vue&type=style&index=0&id=37a4711f&lang=less&scoped=true"

import exportComponent from "/Users/julianzeng/Desktop/Buz/mainland/fuwangleyou-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a4711f"]])

export default __exports__